import React, { useState, useEffect } from "react";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { getFirestore, doc, setDoc } from "firebase/firestore";
import { auth } from "../../../firebaseConfig";
import { SignUpContainer, SignUpForm, SignUpTitle } from "./SignUpContainer";
import { app } from "../../../firebaseConfig"; // Import the Firebase configuration


const SignUp: React.FC = () => {
  const [title, setTitle] = useState("");
  const [firstName, setFirstName] = useState("");
  const [surname, setSurname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string>("");

  useEffect(() => {
    // Initialize Firestore
    const db = getFirestore(app);
  }, []);

  const handleSignUp = async () => {
    try {
      console.log("Attempting to sign up...");

      // Perform password validation here (minimum 8 characters, one number, one uppercase, one lowercase, one special character)
      const passwordPattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).{8,}$/;
      if (!password.match(passwordPattern)) {
        setError("Password must meet the requirements.");
        return;
      }

      // Create the user in Firebase Authentication
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Store additional user information in Firestore
      const db = getFirestore();
      const userRef = doc(db, "users", user.uid);
      await setDoc(userRef, {
        title,
        firstName,
        surname,
        email,
      });

      console.log("User signed up successfully!");
      // You can do something here after successful sign-up, e.g., redirect to another page

    } catch (error) {
      console.error("Error during sign up:", error);
      if (typeof error === "string") {
        setError(error);
      } else {
        setError("An error occurred while signing up.");
      }
    }
  };

  return (
    <SignUpContainer style={{ width: '360px' }}>
      <SignUpForm>
        <SignUpTitle>Sign Up</SignUpTitle>
        
        {/* Custom dropdown with placeholder */}
        <div className="custom-dropdown">
          <select
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className={title ? "selected" : ""}
          >
            <option value="" disabled>
              Title
            </option>
            <option value="Mr.">Mr.</option>
            <option value="Mrs.">Mrs.</option>
            <option value="Miss">Miss</option>
            {/* Add more options as needed */}
          </select>
        </div>
        
        <input
          type="text"
          placeholder="First Name"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />
        <input
          type="text"
          placeholder="Surname"
          value={surname}
          onChange={(e) => setSurname(e.target.value)}
        />
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {error && <p className="error">{error}</p>}
        <button type="button" onClick={handleSignUp}>Sign Up</button>
        
      </SignUpForm>
    </SignUpContainer>
  );
};

export default SignUp;
